import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";

const Testimonial = () => {
  const clients = [
    {
      img: 'https://hapakenya.com/wp-content/uploads/2014/08/TaniyaIvy-06-18-11-086Final-Ivy-KIbera.jpg',
      review:
        "Working with Gilbert was a game-changer! 🚀 His web development skills are off the charts, and he brought our project to life with his React, PHP, and Node.js expertise. 🌐💻🔥 His dedication to quality and meeting deadlines is impressive. We now have a stunning website that wows our users. Thanks to Gilbert, our digital presence is stronger than ever! 🌟👏",
    },
    {
      img: 'https://www.shutterstock.com/shutterstock/photos/2179832821/display_1500/stock-photo-creative-emotional-portraits-of-young-mid-adult-kenyan-black-male-man-with-bald-head-beards-simply-2179832821.jpg',
      review:
        "Gilbert is a web development wizard! 🪄 His React, PHP, and Node.js skills are unmatched, and he completely transformed our website. 🌐💼✨ Working with him was a breeze, and the results speak for themselves. Thanks to Gilbert, our online presence is now a powerhouse. 🚀💪",
    },
    {
      img: 'https://diasporamessenger.com/wp-content/uploads/2013/10/Nick-Mutuma.jpg',
      review:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ex officiis molestiae quod tempora laudantium, cumque error a nisi placeat quae exercitationem, maiores reiciendis! Eaque dicta minima, iure maiores dolorum sed.",
    },
    {
      img: 'https://cdn.standardmedia.co.ke/sdemedia/sdeimages/pulse/black-man1-11113.jpg',
      review:
        "Your web development prowess is truly remarkable! With your expertise in React, PHP, and Node.js, our website underwent a complete transformation. Your commitment to excellence and on-time delivery are truly commendable. Thanks to your skills, our digital presence has reached new heights! 🚀🌐💪🌟",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Clients always get </span>
        <span>Exceptional Work </span>
        <span>from me...</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span style={{ fontSize: "14px" }}>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
